import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { LogoMark, Wordmark } from "./Logo";
import { SITE, TEL_HREF } from "@/siteConfig";

const NAV = [
  { href: "#servizi", label: "Servizi" },
  { href: "#come-funziona", label: "Come funziona" },
  { href: "#zona", label: "Zone" },
  { href: "#faq", label: "FAQ" },
  { href: "#contatti", label: "Contatti" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-300 ${
        scrolled
          ? "border-white/10 bg-[#0A0D12]/85 backdrop-blur-xl"
          : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <a
          href={isHome ? "#top" : "/"}
          data-testid="header-logo-link"
          className="flex items-center gap-3"
          aria-label="FIX ROMA H24 — torna all'inizio"
        >
          <LogoMark className="h-9 w-9" />
          <Wordmark />
        </a>

        <nav
          className="hidden lg:flex items-center gap-7"
          aria-label="Navigazione principale"
        >
          {NAV.map((item) => (
            <a
              key={item.href}
              href={isHome ? item.href : `/${item.href}`}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm text-zinc-400 transition-colors hover:text-amber-400"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href={TEL_HREF}
          data-testid="header-call-button"
          className="group flex items-center gap-2 rounded-full bg-amber-400 px-4 py-2.5 text-sm font-bold text-zinc-950 transition-all hover:bg-amber-300 hover:shadow-[0_0_28px_rgba(245,158,11,0.35)]"
        >
          <Phone className="h-4 w-4 transition-transform group-hover:rotate-12" />
          <span className="hidden sm:inline">{SITE.phoneDisplay}</span>
          <span className="sm:hidden">Chiama</span>
        </a>
      </div>
    </header>
  );
};
